module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/oranges_9a85d5.jpg";